module.exports = __webpack_public_path__ + "img/مستطیل-افقی.ae13f424.png";